<script>
    import { querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Responsivetable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import { push } from 'svelte-spa-router';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { api_host, all_jobs_store, user_store, company_details_store } from '../../stores.js';
    import { init_data } from '../../init.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { state_codes, show_alert } from '../../globals.js';
    import { getFormatDateByOffset, formatDate, get_job_status, formatter, sort_functions } from '../../utils/format.js';
    import Swal from "sweetalert2";


    let is_busy = false;
    let is_date_filter = false;
    let prev_filter = undefined;
    let page_filter = "all";
    let is_mounted = false;
    let jobs = [];
    let filtered_jobs = [];
    let statistic_data = {};
    let onclick_action = {};
    let select_count = 0;
    let date_range_obj = undefined;
    let from_date = false;
    let to_date = false;
    let myself = {};
    let is_notification_success = false;
    let is_notification_warning = false;
    let warnings = [];
    let successes = [];
    $: selected_items = filtered_jobs.filter(e => (e.selection_marked && e.pt === 'Credit Card'));

    let google;
	let map;
	let markers = [];
    let infowindows = [];
	let marker_visible_ids = [];
	let center = { lat: 0, lng: 0 };
    let company_details = {};
    let company_location = null;
    let directionsService;
    let directionsRenderer;

    let table_header_config = [
        {'t': 'Client', 'fm': 'cn', 'a': true},
        {'t': 'Crew', 'fm': 'rn', 'a': true},
        {'t': 'Email', 'fm': 'e', 'a': false},
        {'t': 'Home Phone', 'fm': 'hp', 'a': false},
        {'t': 'Cell Phone', 'fm': 'cp', 'a': false},
        {'t': 'Address', 'fm': 'a', 'a': false},
        {'t': 'City', 'fm': 'c', 'a': true},
        {'t': 'Date / Time', 'fm': 'dt', 'a': true},
        {'t': 'Service Frequency', 'fm': 'sf', 'a': false},
        {'t': 'Lawn Type', 'fm': 'lt', 'a': false},
        {'t': 'Service Type', 'fm': 'st', 'a': false},
        {'t': 'Price', 'fm': 'p', 'a': true},
        {'t': 'Contractor Price', 'fm': 'ud', 'a': false},
        {'t': 'Payment Type', 'fm': 'pt', 'a': false},
        {'t': 'Status', 'fm': 's', 'a': true},
        {'t': 'Additional Comments', 'fm': 'ac', 'a': false},
        {'t': 'Internal Comments', 'fm': 'ic', 'a': false},
        {'t': 'Map', 'fm': 'map', 'a': true }
    ];

    user_store.subscribe(value => {
        myself = value;
    });
    company_details_store.subscribe(value => {
        console.log('company_details', value);
        company_details = value;    
    });

    const { auth_type, auth_token, domain_code } = getToken();
    
    let today = getFormatDateByOffset(0);
    let tomorrow = getFormatDateByOffset(1);
    let yesterday = getFormatDateByOffset(-1);

    let update_date_filter_status = (status) => {
        is_date_filter = status;
        process_params($querystring, is_date_filter);
    }

    let set_date_range_obj = (obj) => {
        date_range_obj = obj;
    }

    const visible_markers = (filtered) => {
        // close all info windows
        infowindows.forEach(_w => _w.close());

        for (let i = 0; i < marker_visible_ids.length; i++) {
            const jid = marker_visible_ids[i];
            let marker = markers.find(m => m[2] === jid);            
            if (!marker) {
                const job = filtered_jobs.find(_j => _j.id === jid);
                const label = job.name;
                const latlng = new google.maps.LatLng(job.lat, job.lng);
                const infowindow = new google.maps.InfoWindow({
                    content: `<div class="info-window">
                        <div>${job.name}</div>
                        <div>${job.a}</div>
                    </div>`,
                    ariaLabel: "Uluru",
                });
                const marker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    animation: google.maps.Animation.DROP,
                    label: label
                });
                marker.addListener("click", () => {
                    infowindow.open({
                        anchor: marker,
                        map,
                    });
                });
                marker.setVisible(false);
                markers.push([marker, job.service_date, job.id]);
                infowindows.push(infowindow);
            }
        }

		if (filtered === true) {
			for (let i = 0; i < markers.length; i ++) {
				if (from_date <= markers[i][1] && markers[i][1] <= to_date) {
					if (marker_visible_ids.includes(markers[i][2])) markers[i][0].setVisible(true);
					else markers[i][0].setVisible(false);
				} else {
					markers[i][0].setVisible(false);
				}
			}
		} else {
			for (let i = 0; i < markers.length; i ++) {
				if (marker_visible_ids.includes(markers[i][2])) {
					markers[i][0].setVisible(true);
				} else {
					markers[i][0].setVisible(false);
				}
			}
		}
	};

    function process_params(qs, first_qs=false) {
        if (document.getElementsByClassName("selectedcontentholder")[0]) {
            document.getElementsByClassName("selectedcontentholder")[0].scrollTop = 0;
        }

        setTimeout(()=>{ window.scrollTo(0, 0); }, 100);

        const params = new URLSearchParams(qs);
        if(params.has('filter')){
            page_filter = params.get('filter');
            if (first_qs) {
                filtered_jobs = jobs;
                return page_filter;
            }
        }
        if (page_filter == 'all') {
            filtered_jobs = jobs;
        } else if (page_filter == 'today') {
            filtered_jobs = jobs.filter(job => job.date_filter == formatDate(today));
        } else if (page_filter == 'yesterday') {
            filtered_jobs = jobs.filter(job => job.date_filter == formatDate(yesterday));
        } else if (page_filter == 'tomorrow') {
            filtered_jobs = jobs.filter(job => job.date_filter == formatDate(tomorrow));
        } else if (page_filter == 'future') {
            filtered_jobs = jobs.filter(job => (new Date(job.date_filter) > new Date(formatDate(today)) && job.status !== 'pending'));
            filtered_jobs.sort((a, b) => {
                if (new Date(a.date_filter) < new Date(b.date_filter)) return 1;
                if (new Date(a.date_filter) > new Date(b.date_filter)) return -1;
                return 0;
            });
        } else if (page_filter == 'past') {
            filtered_jobs = jobs.filter(job => new Date(job.date_filter) < new Date(formatDate(today)));
        } else if (page_filter == 'not_assigned') {
            filtered_jobs = jobs.filter(job => job.status == 'not_assigned');
        } else if (page_filter == 'assigned') {
            filtered_jobs = jobs.filter(job => job.status == 'assigned');
        } else if (page_filter == 'card_declined') {
            filtered_jobs = jobs.filter(job => job.status == 'card_declined');
        } else {
            filtered_jobs = jobs.filter(job => job.s.toLowerCase() == page_filter.toLowerCase());
            if (page_filter === 'unpaid') {
                filtered_jobs.sort((a, b) => {
                    if (new Date(a.date_filter) < new Date(b.date_filter)) return 1;
                    if (new Date(a.date_filter) > new Date(b.date_filter)) return -1;
                    return 0;
                });
            }
        }

        let lats = 0, lngs = 0;
        filtered_jobs.forEach(_j => {
            lats += _j.lat;
            lngs += _j.lng;
        });
        center.lat = filtered_jobs.length == 0 ? 0 : lats / filtered_jobs.length;
		center.lng = filtered_jobs.length == 0 ? 0 : lngs / filtered_jobs.length;
        marker_visible_ids = [];
        visible_markers(false);
        if (directionsRenderer) directionsRenderer.setDirections({ routes: [] });
        showDefaultMap();

        let total_prices = 0, total_crew_prices = 0;
        total_prices = filtered_jobs.reduce((acc, job) => {
            return acc + job.total_service_price;
        }, 0);
        total_crew_prices = filtered_jobs.reduce((acc, job) => {
            return acc + ((job.crews[0] && job.crews[0].role === 'contractor') ? parseFloat(job.total_contractor_price || 0) : 0);
        }, 0);
        statistic_data = {
            'id': 'statistic', 'cn': '', 'rn': '', 'e': '', 'hp': '', 'cp': '', 'a': '', 'c': '', 'dt': '', 'sf': '', 'lt': '', 'st': '', 'p': formatter.format(total_prices), 'ud': formatter.format(total_crew_prices), 'pt': '', 's': '',
            'ac': '', 'ic': '', 'map': `<a href='/' onclick="clear_map(event)">Clear Map</a>`
        };
        onclick_action = {
            'ac': (v) => show_alert('Additional Comments', v),
            'ic': (v) => show_alert('Internal Comments', v),
        };

        if (prev_filter && prev_filter !== page_filter) {
            if (date_range_obj) {
                date_range_obj.clear();
                from_date = false;
                to_date = false;
            }
        }
        prev_filter = page_filter;

        console.log(page_filter, center);

        const today1 = new Date();
        const tomorrow1 = new Date(today1);
        tomorrow1.setDate(today1.getDate() + 1);
        const yesterday1 = new Date(today1);
        yesterday1.setDate(today1.getDate() - 1);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        if (page_filter == 'today') {
            return `today, ${days[today1.getDay()]}`;
        } else if (page_filter == 'tomorrow') {
            return `tomorrow, ${days[tomorrow1.getDay()]}`;
        } else if (page_filter == 'yesterday') {
            return `yesterday, ${days[yesterday1.getDay()]}`;
        }
        return page_filter;
    }

    $: content_title = "Jobs - " + process_params($querystring).replace('_', ' ');

    let show_items = [
        {
            "id": "show",
            "i": "fas fa-eye",
            "s": "color: #1c54b2;",
            "f": (id) => {push("#/Job_Review?jid=" + id); },
            "l": "#/Job_Review?jid=<action_id>"
        },
    ];
    let action_items = [
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": async (id) => {
            const delete_job = jobs.filter(job => job.id === id);
            if (delete_job.length) {
                const status = delete_job[0].status.toLowerCase();
                if (status === 'charged' || status === 'unpaid' || status === 'refunded' || status === 'card_declined' || status === 'approved') {
                    toast_message(false, 'Cannot delete completed job', 2000);
                    return;
                }
            }

            Swal.fire({
                title: "Delete this job?",
                text: '',
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'Ok',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "warning"
            }).then(async (e) => {
                if (e.isConfirmed) {
                    const res = await doFetch(
                        `${api_host}/api/job/delete`,
                        'POST',
                        { job_id: id },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        filtered_jobs = filtered_jobs.filter(job => job.id !== id);
                    } else {
                        toast_message(false, res.msg || 'Bad request', 2000);
                    }
                }
            });
        }},
    ];

    let field_formats = {
        "p": (p) => {
            if (typeof(p) === "string" && !p.startsWith("$")) {
                var formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});
                return formatter.format(parseFloat(p));
            } else {
                return p;
            }
        },
        "ac": (ac) => {
            return ac && ac.length > 15 ? `${ac.substring(0, 15)}...` : ac;
        },
        "ic": (ic) => {
            return ic && ic.length > 15 ? `${ic.substring(0, 15)}...` : ic;
        },
    };

    let field_styles = {
    }

    all_jobs_store.subscribe(value => {
        if (value.length === 0) return;
        jobs = [];
        for (let i = 0; i < value.length; i ++) {
            const job = value[i];
            let crews = '';
            for (let j = 0; j < job.crews.length; j ++) {
                const crew = job.crews[j];
                crews += `<a sortValue='${crew.first_name + " " + crew.last_name}' href='/#/User_Review?uid=${crew.id}' style='display: block;'>${crew.first_name} ${crew.last_name}</a>`;
            }
            jobs.push({
                "crews": job.crews,
                "rn": crews ? crews : 'Not Assigned',
                "id": job.id,
                'name': job.client.first_name + ' ' + job.client.last_name,
                "cn": `<a sortValue='${job.client.first_name + " " + job.client.last_name}' href='/#/User_Review?uid=${job.uid}'>${job.client.first_name + " " + job.client.last_name}</a>`,
                "e": job.email,
                "hp": job.home_phone,
                "cp": job.mobile_phone,
                "a": `${job.address}, ${job.city}, ${(state_codes[job.state] || job.state)}`,
                "c": job.city,
                "dt": `${formatDate(job.service_date)} - ${job.time_preference}`,
                "lt": job.lawn,
                "st": job.service_type,
                "sf": job.service_frequency,
                "p": `${job.total_service_price.toFixed(2)}`,
                "total_service_price": job.total_service_price,
                "ud": `${job.total_contractor_price.toFixed(2)}`,
                "total_contractor_price": job.total_contractor_price,
                "pt": job.paymethod,
                "s": get_job_status(job.status),
                "status": job.status,
                "co": formatDate(job.created_at),
                "date_filter": myself.plan_type === 'basic' ? formatDate(job.created_at) : formatDate(job.service_date),
                "ac": job.additional_comments,
                "ic": job.internal_comments,
                "lat": job.lat,
                "lng": job.lng,
                "map": `<input type="checkbox" class="map-checkbox" id="${job.id}" name="${job.id}" value="${job.id}" lat="${job.lat}" lng="${job.lng}" onchange="select_map(event)" />`,
            });
        }
        jobs.sort((a, b) => {
            if (a.cn.toLowerCase() < b.cn.toLowerCase()) return -1;
            if (a.cn.toLowerCase() > b.cn.toLowerCase()) return 1;
            if (new Date(a.date_filter) < new Date(b.date_filter)) return 1;
            if (new Date(a.date_filter) > new Date(b.date_filter)) return -1;
            return 0;
        });
        process_params($querystring);
        setTimeout(()=>{ is_mounted = true; }, 250);
    });

    onMount(async () => {
        if (document.getElementsByClassName("selectedcontentholder")[0]) {
            document.getElementsByClassName("selectedcontentholder")[0].scrollTop = 0;
        }
    });

    function showDefaultMap() {
        if (!map) return;
        console.log('show default map');
        if (company_location?.lat) {
            map.setCenter(company_location);
            map.setZoom(7);
        } else {
            map.setZoom(1);
        }
    }
    $: {
		if (is_mounted && jobs.length > 0 && company_location === null) {
			if (!markers.length) {
                if (!map) {
                    google = window.google;
		            map = document.getElementById("map-canvas");

                    center = { lat: 34.483635, lng: -111.669098 };
                    const mapOptions = {
                        zoom: 1,
                        scrollwheel: false,
                        center: center,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                    };

                    map = new google.maps.Map(map, mapOptions);
                    directionsService = new google.maps.DirectionsService();
                    directionsRenderer = new google.maps.DirectionsRenderer({suppressMarkers: true});
                    directionsRenderer.setMap(map);
                }

                const geocoder = new google.maps.Geocoder();
                const address = `${company_details.address}, ${company_details.city}, ${company_details.state}`;
                console.log('address', address);
                geocoder.geocode({ 'address': address }, function(results, status) {
                    if (status === 'OK') {
                        company_location = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                        console.log('company location', company_location);
                        showDefaultMap();
                    }
                });
			} else {
				// if (from_date && to_date) {
				// 	visible_markers(true);
				// } else {
				// 	visible_markers(false);
				// }
				visible_markers(false);
			}
		}
	}

    window.clear_map = (event) => {
        if (!map || !directionsRenderer) return;
        console.log('clear map');
        const elements = document.getElementsByClassName('map-checkbox');
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].checked) elements[i].checked = false;
        }
        marker_visible_ids = [];
        visible_markers(false);
        console.log(directionsRenderer);
        directionsRenderer.setDirections({ routes: [] });
        showDefaultMap();
        if (event)
            event.preventDefault();
    }

    window.select_map = (event) => {
		const jid = parseInt(event.target.value);
		if (event.target.checked === true) {
            const job = filtered_jobs.find(_j => _j.id === jid);
            if (job.lat !== undefined && job.lng !== undefined && job.lat !== 200 && job.lng !== 200) {
			    marker_visible_ids.push(jid);
            }
		} else {
			marker_visible_ids = marker_visible_ids.filter(_jid => _jid !== jid);
		}

		// if (from_date && to_date) {
		// 	visible_markers(true);
		// } else {
		// 	visible_markers(false);
		// }
		visible_markers(false);
        directionsRenderer.setDirections({ routes: [] });
        if (marker_visible_ids.length === 0) {
            showDefaultMap();
            return;
        }

        if (marker_visible_ids.length === 1) {
            const job = filtered_jobs.find(_j => _j.id === marker_visible_ids[0]);
            map.setCenter({ lat: job.lat, lng: job.lng });
            map.setZoom(15);
        } else {
            const bounds = new google.maps.LatLngBounds();
            const locations = [];
            marker_visible_ids.forEach(jid => {
                const job = filtered_jobs.find(_j => _j.id === jid);
                bounds.extend({ lat: job.lat, lng: job.lng });
                locations.push({ lat: job.lat, lng: job.lng });
            });
            map.fitBounds(bounds);

            // draw route
            const waypoints = locations.slice(1, locations.length - 1).map(location => ({
                location: new google.maps.LatLng(location.lat, location.lng),
                stopover: true
            }));

            directionsService.route(
                {
                    origin: new google.maps.LatLng(locations[0].lat, locations[0].lng),
                    destination: new google.maps.LatLng(locations[locations.length - 1].lat, locations[locations.length - 1].lng),
                    waypoints: waypoints,
                    optimizeWaypoints: true,
                    travelMode: google.maps.TravelMode.DRIVING
                },
                (response, status) => {
                    if (status === "OK") {
                        directionsRenderer.setDirections(response);
                    } else {
                        
                    }
                }
            );
        }
	}
    
    let date_value = '';

    let selections_selected = false;
    let at_least_one_selected = false;
    const chargeSelected = async () => {
        const items = [...selected_items];
        if (is_busy) return;
        is_busy = true;
        await Swal.fire({
            title: "Charge selected clients?",
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'Ok',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "success"
        }).then(async (e) => {
            if (e.isConfirmed) {
                try {
                    let is_duplicated = false;
                    is_notification_success = false;
                    is_notification_warning = false;
                    successes = [];
                    warnings = [];
                    for (let i = 0; i < items.length; i ++) {
                        const selected_item = items[i];
                        const res = await doFetch(
                            `${api_host}/api/job/update/status`,
                            'POST',
                            { job_id: selected_item.id, action: 'charge', payment_status: true },
                            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                        );
                        if (res.status) {
                            if (res.msg === 'Card Declined') {
                                if (is_duplicated !== true) warnings.push(`${selected_item.name}, ${res.msg}`);
                            } else {
                                if (res.action_status) {
                                    successes.push(`${selected_item.name}, ${res.msg}`);
                                } else {
                                    const err_msg = `${selected_item.name}, ${res.msg}`;
                                    if (!warnings.includes(err_msg))
                                        warnings.push(err_msg);
                                }
                            }
                        } else {
                            if (!warnings.includes(selected_item.name)) {
                                if (res.msg?.includes('Set up payment setting first')) {
                                    is_duplicated = true;
                                    warnings = ['Set up payment setting first'];
                                }
                            }
                            if (is_duplicated !== true) {
                                warnings.push(`${selected_item.name}, ${(res.msg || 'Failed charge')}`);
                            }
                        }
                    }
                    console.log(warnings);
                    if (successes.length > 0) is_notification_success = true;
                    if (warnings.length > 0) is_notification_warning = true;

                    await init_data('jobs');
                    for (let i = 0; i < filtered_jobs.length; i ++){
                        filtered_jobs[i].selection_marked = false;
                    }
                    selections_selected = false;
                    for (let job_i in filtered_jobs) {
                        filtered_jobs[job_i].selection_marked = false;
                    }
                    select_count = 0;
                } catch (error) {
                    toast_message(false, error, 3000);
                    selections_selected = false;
                    select_count = 0;
                }
            }
        });
        is_busy = false;
    };
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

{#if is_notification_warning}
    <div class='notification_container warning'>
        {#each warnings as warning}
            <span>{warning}</span>
        {/each}
        <i class='fas fa-close' on:click={() => { is_notification_warning = false; }}></i>
    </div>
{/if}
{#if is_notification_success}
    <div class='notification_container success'>
        {#each successes as success}
            <span>{success}</span>
        {/each}
        <i class='fas fa-close' on:click={() => { is_notification_success = false; }}></i>
    </div>
{/if}

<div class="contentholder">
    {#if page_filter !== 'unpaid' && page_filter !== 'pending' && myself.plan_type !== 'basic'}
    <div class="buttonholder">
        <button
            class={`charge ${(!(selections_selected || at_least_one_selected) || !selected_items.length) || is_busy ? 'buttondisabled' : ''}`}
            on:click={() => {chargeSelected();}} disabled={(!(selections_selected || at_least_one_selected) || !selected_items.length) || is_busy}
        >
            <i class="fas fa-file-invoice-dollar"></i>
            Charge Selected Jobs
        </button>
    </div>
    {/if}

    {#if is_mounted}
        <div class="jobtableholder">
            <Responsivetable
                field_formats={field_formats}
                field_styles={field_styles}
                sort_functions={sort_functions}
                statistic_data={statistic_data}
                onclick_action={onclick_action}
                num_per_page={500}
                date_filter_param='dt'
                show_selections = {(page_filter !== 'unpaid' && page_filter !== 'pending')}
                selections_title = "Charge"
                show_date_range={true}
                action_items_title='Remove'
                selected_word='job'
                init_type='jobs'
                refresh_action='jobs'
                bind:is_busy={is_busy}
                bind:update_date_filter_status={update_date_filter_status}
                bind:set_date_range_obj={set_date_range_obj}
                bind:from_date={from_date}
                bind:to_date={to_date}
                bind:table_header_config={table_header_config}
                bind:table_data={filtered_jobs}
                bind:select_count={select_count}
                bind:total_items={jobs.length}
                bind:action_items={action_items}
                bind:show_items={show_items}
                bind:selections_selected={selections_selected}
                bind:at_least_one_selected={at_least_one_selected}
                bind:date_value={date_value}
            />
        </div>
    {/if}

    <div class="map-container">
        <div
            id="map-canvas"
            class="relative w-full rounded h-600-px"
            data-lat="40.748817"
            data-lng="-73.985428"
            style={`width: 100%; height: 500px; margin-top: 40px;`}
        ></div>
    </div>

</div>

<style>
    .notification_container {
        padding: 10px 15px 10px 15px;
        margin-top: 10px;
        position: relative;
    }
    .notification_container.warning {
        background-color: #ffecec;
        color: #a10000;
    }
    .notification_container.success {
        background-color: #c1e7c1;
        color: #004400;
    }
    .notification_container span {
        display: block;
    }
    .notification_container i {
        position: absolute;
        top: 5px;
        right: 7px;
        cursor: pointer;
    }
    .contentholder {
        padding: 0px;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
    }
    .buttonholder button.charge {
        background-color: #ff9100;
        color: white;
    }
    .buttondisabled {
        cursor: not-allowed;
        opacity: 0.8;
    }
    :global(.flatpickr-input) {
        width: 250px;
    }
    .map-container {
        padding-right: 100px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            width: 100%;
        }
        .map-container {
            padding-right: 0px;
        }
    }
</style>